"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUWDecision = exports.GET_UW_DECISION = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _reduxActions = require("redux-actions");

var _httpActions = require("./http-actions");

// TODO: payment may be derived per server call for a given amount
var FAKE_RESULT = {
  data: {
    applicationUuid: '',
    decision: 'PREAPPROVED',
    // may be DENIED, PROCESSING, etc.
    // TODO: need to calculate monthly payment
    products: [{
      min: 0,
      max: 186314.6,
      tier: 1,
      term: 3,
      rate: 0.05
    }, {
      min: 0,
      max: 186314.6,
      tier: 1,
      term: 5,
      rate: 0.0525
    }, {
      min: 0,
      max: 186314.6,
      tier: 1,
      term: 7,
      rate: 0.055
    }, {
      min: 0,
      max: 186314.6,
      tier: 1,
      term: 10,
      rate: 0.0575
    }, // tier 2
    {
      min: 186314.61,
      max: 223577.53,
      tier: 2,
      term: 3,
      rate: 0.055
    }, {
      min: 186314.61,
      max: 223577.53,
      tier: 2,
      term: 5,
      rate: 0.06
    }, {
      min: 186314.61,
      max: 223577.53,
      tier: 2,
      term: 7,
      rate: 0.065
    }, {
      min: 186314.61,
      max: 223577.53,
      tier: 2,
      term: 10,
      rate: 0.07
    }, // tier 3
    {
      min: 223577.54,
      max: 279471.91,
      tier: 3,
      term: 3,
      rate: 0.06
    }, {
      min: 223577.54,
      max: 279471.91,
      tier: 3,
      term: 5,
      rate: 0.0675
    }, {
      min: 223577.54,
      max: 279471.91,
      tier: 3,
      term: 7,
      rate: 0.075
    }, {
      min: 223577.54,
      max: 279471.91,
      tier: 3,
      term: 10,
      rate: 0.085
    }]
  }
};
var GET_UW_DECISION = 'GET_UW_DECISION';
/**
 * @deprecated Use offer actions for actual data from server, this is just stubs
 */

exports.GET_UW_DECISION = GET_UW_DECISION;

var getUWDecision = function getUWDecision(applicationUuid) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch((0, _reduxActions.createAction)("".concat(GET_UW_DECISION, "_").concat(_httpActions.REQUEST))()); // fake ajax call until service is available

              return _context.abrupt("return", new Promise(function (resolve) {
                window.setTimeout(function () {
                  // attach uuid to same fake payload
                  var data = Object.assign({}, FAKE_RESULT.data, {
                    applicationUuid: applicationUuid
                  });
                  dispatch((0, _reduxActions.createAction)("".concat(GET_UW_DECISION, "_").concat(_httpActions.SUCCESS))(data));
                  resolve(data);
                }, 500);
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getUWDecision = getUWDecision;